import React, { useContext } from 'react';
import DocumentUploadContext from '../../context/DocumentUpload/documentUploadContext';
import SchedulerMain from '../../pages/SchedulerMain';
import ActivateCardMain from '../../pages/ActivateCardMain';
import Upload from '../../pages/Upload';
import SelectSchedule from '../../pages/SelectSchedule';
import Acknowledgement from '../../pages/Acknowledgement';
import NoticePage from '../../pages/NoticePage';
import SelectScheduleSummary from '../../pages/SelectScheduleSummary';
import SchedulerAcknowledgement from '../../pages/SchedulerAcknowledgement';
import ActivateCardMobileNumber from '../../pages/ActivateCardMobileNumber';
import ActivateCardNominatePin from '../../pages/ActivateCardNominatePin';
import ActivateCardAcknowledgement from '../../pages/ActivateCardAcknowledgement';

const ActivateCardForm = () => {
  const documentUploadContext = useContext(DocumentUploadContext);
  const currentURL = window.location.href;
  switch (documentUploadContext.step) {
    case 0:
      return <ActivateCardMain />;
    case 1:
      return currentURL.includes("Scheduler") ? <SelectSchedule /> : <Upload /> ;
    case 2:
      return <Acknowledgement />;
    case 3:
      return <NoticePage />;
    case 4:
      return <SelectScheduleSummary />;
    case 5:
      return <SchedulerAcknowledgement />;
    case 6:
      return <ActivateCardNominatePin />;
    case 7:
      return <ActivateCardAcknowledgement />;
    case 8:
      return <ActivateCardMobileNumber />;
    default:
      return <h1>{''}</h1>;
  }
};
export default ActivateCardForm;
